import {
  GET_LIST_PRE_ORDER_CAMPAIGNS_REQUEST,
  GET_LIST_PRE_ORDER_CAMPAIGNS_SUCCESS,
  GET_LIST_PRE_ORDER_CAMPAIGNS_FAILURE,
  GET_PRE_ORDER_CAMPAIGN_FAILURE,
  GET_PRE_ORDER_CAMPAIGN_REQUEST,
  GET_PRE_ORDER_CAMPAIGN_SUCCESS,
  UPDATE_PRE_ORDER_CAMPAIGN_FAILURE,
  UPDATE_PRE_ORDER_CAMPAIGN_REQUEST,
  UPDATE_PRE_ORDER_CAMPAIGN_SUCCESS,
  CREATE_PRE_ORDER_CAMPAIGN_REQUEST,
  CREATE_PRE_ORDER_CAMPAIGN_SUCCESS,
  CREATE_PRE_ORDER_CAMPAIGN_FAILURE,
  DUPLICATE_PRE_ORDER_CAMPAIGN_REQUEST,
  DUPLICATE_PRE_ORDER_CAMPAIGN_SUCCESS,
  DUPLICATE_PRE_ORDER_CAMPAIGN_FAILURE,
  DELETE_PRE_ORDER_CAMPAIGN_REQUEST,
  DELETE_PRE_ORDER_CAMPAIGN_SUCCESS,
  DELETE_PRE_ORDER_CAMPAIGN_FAILURE,
  GET_PRE_ORDER_GENERAL_SETTINGS_SUCCESS,
  GET_PRE_ORDER_GENERAL_SETTINGS_FAILURE,
  UPDATE_PRE_ORDER_GENERAL_SETTINGS_REQUEST,
  UPDATE_PRE_ORDER_GENERAL_SETTINGS_SUCCESS,
  UPDATE_PRE_ORDER_GENERAL_SETTINGS_FAILURE,
  GET_PRE_ORDER_GENERAL_SETTINGS_REQUEST
} from 'src/stores/flow-type/pre-order.type';

const initialState = {
  loading: false,
  success: false,
  saving: false,
  savingSuccess: false,
  deleting: false,
  deleteSuccess: false,
  generalSettings: {},
  campaign: {},
  list: [
    {
      name: 'Pre-order 01',
      status: 'paused',
      product: {
        type: 'specific',
        list: ['', '']
      },
      stockCondition: 'out-of-stock', // | 'always' | 'limited',
      payment: {
        type: 'partial', // | 'partial' | 'none'
        discountType: 'percentage', // | 'amount' | 'none',
        discountValue: 10,
        upfrontValue: 10,
        finalPayment: {
          type: 'daysAfterCheckout', //| 'daysAfterCheckout'
          valueDate: 0, // = 0 if days after checkout
          valueDays: 10 // = null if days after checkout
        }
      },
      deliveryPolicy: {
        type: 'asap', // | 'specificDate' | 'numberOfDays' | 'none',
        valueDate: 0, // = 0 if type != specificDate
        valueDays: null // = null if type != numberOfDays
      },
      inventoryPolicy: 'onSell' // | 'onFulfillment',
    },
    {
      name: 'Pre-order 01',
      status: 'active',
      product: {
        type: 'specific',
        list: ['', '']
      },
      stockCondition: 'out-of-stock', // | 'always' | 'limited',
      payment: {
        type: 'full', // | 'partial' | 'none'
        discountType: 'percentage', // | 'amount' | 'none',
        discountValue: 10,
        upfrontValue: 10,
        finalPayment: {
          type: 'daysAfterCheckout', //| 'daysAfterCheckout'
          valueDate: 0, // = 0 if days after checkout
          valueDays: 10 // = null if days after checkout
        }
      },
      deliveryPolicy: {
        type: 'asap', // | 'specificDate' | 'numberOfDays' | 'none',
        valueDate: 0, // = 0 if type != specificDate
        valueDays: null // = null if type != numberOfDays
      },
      inventoryPolicy: 'onSell' // | 'onFulfillment',
    }
  ],
  total: 0,
  totalAll: 0
};

const preOrderReducers = (state = initialState, action) => {
  switch (action.type) {
    // Get campaigns list
    case GET_LIST_PRE_ORDER_CAMPAIGNS_REQUEST:
      return { ...state, loading: true, success: false };
    case GET_LIST_PRE_ORDER_CAMPAIGNS_SUCCESS: {
      const data = action.payload.data || {};
      return {
        ...state,
        loading: false,
        success: true,
        list: data?.list || [],
        total: data?.total || 0,
        totalAll: data?.totalAll || 0,
        error: undefined
      };
    }
    case GET_LIST_PRE_ORDER_CAMPAIGNS_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      };
    // Get product performance ranking
    case GET_PRE_ORDER_CAMPAIGN_REQUEST:
      return { ...state, loading: true, success: false };
    case GET_PRE_ORDER_CAMPAIGN_SUCCESS: {
      return {
        ...state,
        loading: false,
        success: true,
        campaign: action.payload.data || {},
        error: undefined
      };
    }
    case GET_PRE_ORDER_CAMPAIGN_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      };

    // create pre-order campaign
    case CREATE_PRE_ORDER_CAMPAIGN_REQUEST:
      return { ...state, saving: true, savingSuccess: false };
    case CREATE_PRE_ORDER_CAMPAIGN_SUCCESS: {
      return {
        ...state,
        saving: false,
        savingSuccess: true,
        campaign: action.payload.data || {},
        error: undefined
      };
    }
    case CREATE_PRE_ORDER_CAMPAIGN_FAILURE:
      return {
        ...state,
        saving: false,
        savingSuccess: false,
        error: action.payload
      };

    // duplicate pre-order campaign
    case DUPLICATE_PRE_ORDER_CAMPAIGN_REQUEST:
      return { ...state, saving: true, savingSuccess: false };
    case DUPLICATE_PRE_ORDER_CAMPAIGN_SUCCESS: {
      const { data } = action.payload;
      const list = state.list || [];
      list.push(data);
      return {
        ...state,
        saving: false,
        savingSuccess: true,
        list,
        error: undefined
      };
    }
    case DUPLICATE_PRE_ORDER_CAMPAIGN_FAILURE:
      return {
        ...state,
        saving: false,
        savingSuccess: false,
        error: action.payload
      };
    // Update pre-order campaign
    case UPDATE_PRE_ORDER_CAMPAIGN_REQUEST:
      return { ...state, saving: true, savingSuccess: false };
    case UPDATE_PRE_ORDER_CAMPAIGN_SUCCESS: {
      return {
        ...state,
        saving: false,
        savingSuccess: true,
        campaign: action.payload.data || {},
        error: undefined
      };
    }
    case UPDATE_PRE_ORDER_CAMPAIGN_FAILURE:
      return {
        ...state,
        saving: false,
        savingSuccess: false,
        error: action.payload
      };

    // delete pre-order campaign
    case DELETE_PRE_ORDER_CAMPAIGN_REQUEST:
      return { ...state, saving: true, savingSuccess: false };
    case DELETE_PRE_ORDER_CAMPAIGN_SUCCESS: {
      const { campaignId } = action.payload;
      const list = state.list.find(cam => cam._id !== campaignId);
      return {
        ...state,
        saving: false,
        savingSuccess: true,
        list,
        error: undefined
      };
    }
    case DELETE_PRE_ORDER_CAMPAIGN_FAILURE:
      return {
        ...state,
        saving: false,
        savingSuccess: false,
        error: action.payload
      };
    // --- general settings
    // get general settings
    case GET_PRE_ORDER_GENERAL_SETTINGS_REQUEST:
      return { ...state, loading: true, success: false };
    case GET_PRE_ORDER_GENERAL_SETTINGS_SUCCESS: {
      return {
        ...state,
        loading: false,
        success: true,
        generalSettings: action.payload.data || {},
        error: undefined
      };
    }
    case GET_PRE_ORDER_GENERAL_SETTINGS_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      };

    // save general settings
    // Update pre-order campaign
    case UPDATE_PRE_ORDER_GENERAL_SETTINGS_REQUEST:
      return { ...state, saving: true, savingSuccess: false };
    case UPDATE_PRE_ORDER_GENERAL_SETTINGS_SUCCESS: {
      return {
        ...state,
        saving: false,
        savingSuccess: true,
        generalSettings: action.payload.data || {},
        error: undefined
      };
    }
    case UPDATE_PRE_ORDER_GENERAL_SETTINGS_FAILURE:
      return {
        ...state,
        saving: false,
        savingSuccess: false,
        error: action.payload
      };

    default:
      return state;
  }
};
export default preOrderReducers;
